import React from 'react';
import style from './index.css';
import BarCode from 'react-barcode';
import NHFetch from "../../NHFetch";

/**
 * 江西应用科技学院报到单页面
 * Author: yangqizhi@ly-sky.com
 * Modify log: 要使用该报到单需在系统配置中配置学校代码为jxyykjxy
 */
export default class JxyykjxyPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            xsxx: this.props.initFormDate,//学生信息
            schoolName: this.props.schoolName,//学校名称
            year: this.props.year,//当前年度
            account: this.props.account,//默认账号
            jzlxdh: "",//家长联系电话
            success: false,
        };
    }

    componentWillMount() {
        NHFetch('api/zhxg-yxxt/yxxc/getJtxxByXsid', 'GET', {xsid: this.state.xsxx.xsid})
          .then(res => {
              if (res && res.data) {
                  this.setState({jzlxdh: res.data['JTDH'] ? res.data['JTDH'] : ""});
              }
          }).then(() => this.setState({success: true}));
    }

    render() {
        const {xsxx, schoolName, year, account, jzlxdh} = this.state;
        return (
          this.state.success ?
            <div className="box" style={{width: '297mm', margin: '0 auto'}}>
                <div>
                    <div style={{textAlign: 'center'}}>
                        <div className={style.title}>
                            江西应用科技学院 {year}年新生报到流程表
                        </div>
                    </div>
                    <div className="dynamicDataDiv">
                        <div className={style.dynamicDataDivContainer}>
                            <div className={style.dynamicDataDivItem}>
                                姓名：<span className={style.dynamicDataDivSpan}>{xsxx.xm}</span>
                            </div>
                            <div className={style.dynamicDataDivItem}>
                                性别：<span className={style.dynamicDataDivSpan}>{xsxx.xb}</span>
                            </div>
                            <div className={style.dynamicDataDivItem}>
                                分院：<span className={style.dynamicDataDivSpan}>{xsxx.bmmc}</span>
                            </div>
                            <div className={style.dynamicDataDivItem}>
                                专业：<span className={style.dynamicDataDivSpan}>{xsxx.zymc}</span>
                            </div>
                            <div className={style.dynamicDataDivItem}>
                                身份证号：<span className={style.dynamicDataDivSpan}>{xsxx.sfzjh}</span>
                            </div>
                        </div>
                        <div className={style.dynamicDataDivContainer}>
                            <div className={style.dynamicDataDivItem}>
                                考生号：<span className={style.dynamicDataDivSpan}>{xsxx.ksh}</span>
                            </div>
                            <div className={style.dynamicDataDivItem}>
                                家庭地址：<span className={style.dynamicDataDivSpan}>{xsxx.jtdz}</span>
                            </div>
                            {jzlxdh.length > 0 ?
                              <div className={style.dynamicDataDivItem}>
                                  家长电话：<span className={style.dynamicDataDivSpan}>{jzlxdh}</span>
                              </div> :
                              <div style={{
                                  height: 'auto',
                                  display: 'inline-block',
                                  color: '#0d0d0d'
                              }}>
                                  <span>家长电话：</span>
                                  <div
                                    style={{
                                        width: 130,
                                        height: 'auto',
                                        wordWrap: 'break-word',
                                        display: 'inline-block',
                                        borderBottom: '1px solid black',
                                        marginBottom: 0,
                                        paddingBottom: 0
                                    }}/>
                              </div>
                            }

                            <div className={style.dynamicDataDivItem}>
                                本人电话：<span className={style.dynamicDataDivSpan}>{xsxx.sjhm}</span>
                            </div>
                        </div>

                    </div>

                    <div className={style.tableDiv}>
                        <table>
                            <tbody>
                            <tr className={style.tableTitle}>
                                <td>一、区域接待</td>
                                <td>二、招生办审核</td>
                                <td colSpan="2">三、缴费</td>
                            </tr>
                            <tr className={style.tableMiniTitle}>
                                <td>地点：图书馆一楼大厅</td>
                                <td>地点：图书馆一楼大厅东侧</td>
                                <td colSpan="2">地点：图书馆一楼大厅东侧</td>
                            </tr>

                            <tr className={style.tableContent} style={{height: 180}}>
                                <td>
                                    <div className={style.contentContainer}>
                                        <div className={style.contentTop}>
                                            1.按照区域找到对应的区域接待点。<br/>
                                        </div>
                                        <div className={style.contentBottom}>
                                            经办人签章：
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <div className={style.contentContainer}>
                                        <div className={style.contentTop}>
                                            1、审核身份、刷身份证原件录入新生报到系统；<br/>
                                            2、领取、填写《2021年新生报到流程表》。<br/>
                                        </div>
                                        <div className={style.contentBottom}>
                                            新生签名： &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            经办人签章：
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <div className={style.contentContainer}>
                                        <div className={style.contentTop}>
                                            1、凭身份证原件、《2021年新生报到<br/>
                                            流程表》缴纳生活用品费，开具生活用<br/>
                                            品领用单；<br/>
                                            2、物业公司收取财产押金。<br/>
                                        </div>
                                        <div className={style.contentBottom}>
                                            经办人签章：
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <div className={style.contentContainer}>
                                        <div className={style.contentTop}>
                                            1、凭身份证原件、《2021年新生报到<br/>
                                            流程表》 缴纳学杂费；<br/>
                                            2、缴费票据等分班后统一发放；<br/>
                                            3、办理校园IC卡。<br/>
                                        </div>
                                        <div className={style.contentBottom}>
                                            经办人签章：
                                        </div>
                                    </div>
                                </td>

                            </tr>

                            <tr className={style.tableTitle}>
                                <td>四、分院报到</td>
                                <td>五、资产处发放生活用品</td>
                                <td colSpan="2">六、楼栋宿管办理入住</td>
                            </tr>
                            <tr className={style.tableMiniTitle}>
                                <td>地点：图书馆一楼大厅西侧</td>
                                <td>地点：大学生活动中心</td>
                                <td colSpan="2">地点：各相关宿舍楼一楼</td>
                            </tr>

                            <tr className={style.tableContent}>
                                <td>
                                    <div className={style.contentContainer}>
                                        <div className={style.contentTop}>
                                            1、报到注册登记；<br/>
                                            2、建立新生档案(上交《录取通知书》、<br/>
                                            一寸照片4张、身份证复印件1张、户口<br/>
                                            本复印件2张(户主页与本人页各1页)、<br/>
                                            准考证原件)；<br/>
                                            3、递交党、团组织关系材料；<br/>
                                            4、按专业分配房间；<br/>
                                            5、开展入学教育；<br/>
                                            6、军训安排（预约日期、军训编队）。<br/>
                                        </div>
                                        <div className={style.contentBottom}>
                                            经办人签章：
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className={style.contentContainer}>
                                        <div className={style.contentTop}>
                                            1、领取生活用品；<br/>
                                            2、领取宿舍用品；<br/>
                                            3、领取军训用品。<br/>
                                        </div>
                                        <div className={style.contentBottom}>
                                            经办人签章：
                                        </div>
                                    </div>
                                </td>
                                <td colSpan="2">
                                    <div className={style.contentContainer}>
                                        <div className={style.contentTop}>
                                            1、领取房间配备物品；<br/>
                                            2、宿管登记入住。<br/>
                                        </div>
                                        <div className={style.contentBottom}>
                                            经办人签章：
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={style.p_sw_big}>
                        <div style={{position: 'relative'}}>
                            <div className={style.bz_item} style={{color: '#000'}}>
                                1、此表各单位盖章有效，新生报到时按流程顺序依次办理入学手续；
                            </div>
                            <div className={style.bz_item} style={{color: '#000'}}>
                                2、请妥善保管此表，完成报到流程后上交到分院，最后由分院统一汇总后提交到档案馆存档。
                            </div>

                        </div>
                    </div>
                    <div style={{position: 'absolute', top: '170mm', right: 60,}}>
                        <BarCode
                          className={style.bz_img}
                          value={account}
                          width={2}
                          height={40}
                          fontSize={14}
                        >
                        </BarCode>
                    </div>
                </div>
            </div>
            :
            null
        );
    }
}



// WEBPACK FOOTER //
// ./components/yxxc/print/Bdd/jxyykjxy/JxyykjxyPrint.js